module.exports = __webpack_public_path__ + "img/tuerueberdachung_2.2cb4ecc0.jpg";